import { Descriptions, Tag } from "antd";
import { type FullInstanceType } from "../redux/slices/midservice/midserviceTypes";
import React from "react";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";

const formatModules = (modules: any[] | undefined): string => {
  if (modules == null) return "";
  let result = "";
  for (let i = 0; i < modules.length; i++) {
    result += String(modules[i]?.module_name);
    if (i !== modules.length - 1) result += ", ";
  }
  return result;
};

const getTT = (fullInstance?: FullInstanceType): JSX.Element => {
  if (fullInstance == null) {
    return <></>;
  }
  const addressString: string = `${
    fullInstance?.obdInfo?.addressName ?? "-"
  }, ${fullInstance?.obdInfo?.addressCity ?? "-"}, ${
    fullInstance?.obdInfo?.addressStreet ?? "-"
  }, ${fullInstance?.obdInfo?.addressCity ?? "-"}, ${
    fullInstance?.obdInfo?.addressHouse ?? "-"
  }`;
  if (
    fullInstance.midserviceInstance.domain != null &&
    fullInstance?.obdInfo?.addressId != null
  ) {
    return (
      <Link
        target="_blank"
        to={`/instances/tt/${fullInstance.midserviceInstance.domain}/${fullInstance?.obdInfo?.addressId}`}
      >
        {addressString} <LinkOutlined />
      </Link>
    );
  }
  return <>{addressString}</>;
};

export const DeviceDescription = ({
  fullInstance,
  instanceType,
}: {
  fullInstance: FullInstanceType | undefined;
  instanceType: "midservice" | "kkm";
}): JSX.Element => {
  return (
    <Descriptions title="Информация" column={1}>
      <Descriptions.Item label="Клиент">{`${
        fullInstance?.midserviceInstance?.networkLogin ?? "-"
      }/${
        fullInstance?.midserviceInstance?.networkName ?? "-"
      }`}</Descriptions.Item>
      <Descriptions.Item label="Торговая точка">
        {getTT(fullInstance)}
      </Descriptions.Item>
      <Descriptions.Item label="Название">
        {fullInstance?.obdInfo?.deviceName}
      </Descriptions.Item>
      <Descriptions.Item label="Тип">
        <Tag>{fullInstance?.midserviceInstance?.instanceType}</Tag>
      </Descriptions.Item>
      {instanceType === "midservice" ? (
        <>
          <Descriptions.Item label="Версия">
            {fullInstance?.midserviceInstance?.status?.version}
          </Descriptions.Item>
          <Descriptions.Item label="Модули">
            {formatModules(fullInstance?.midserviceInstance?.status?.modules)}
          </Descriptions.Item>
          <Descriptions.Item label="Железо">
            {fullInstance?.midserviceInstance?.status?.hardware}
          </Descriptions.Item>
          <Descriptions.Item label="ОС">
            {fullInstance?.midserviceInstance?.status?.os}
          </Descriptions.Item>
        </>
      ) : (
        <>
          <Descriptions.Item label="Версия">
            {fullInstance?.midserviceInstance?.initInfo?.appVersion}
          </Descriptions.Item>
          <Descriptions.Item label="Модули">
            {JSON.stringify(
              fullInstance?.midserviceInstance?.status?.appdata?.interactors,
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Железо">
            {fullInstance?.midserviceInstance?.initInfo?.deviceName}
          </Descriptions.Item>
          <Descriptions.Item label="ОС">
            {fullInstance?.midserviceInstance?.initInfo?.osVersion}
          </Descriptions.Item>
        </>
      )}
    </Descriptions>
  );
};
